import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';
import Spacer from 'design-system/Spacer';
import { AppView } from 'design-system/AppView';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import InfoCardWithIndex from 'design-system/InfoCardWithIndex';
import Button, { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { selectAlpacaAccountClosingLongDate } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const SecclMigrationExpectations = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const dispatch = useAppDispatch();
    const colors = useColors();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    const alpacaClosingDate = useAppSelector(selectAlpacaAccountClosingLongDate);
    const handleGoBack = useCallback(() => {
        navigation.pop();
        dispatch(setDeviceSettingsKey('didViewSecclMigrationIntro', true));
    }, []);
    const handleContinue = useCallback(() => {
        handleGoBack();
        navigation.navigate('InvestSelectSecclAccountType');
    }, [handleGoBack]);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    useEffect(() => {
        if (!alpacaClosingDate) {
            navigation.popToTop();
        }
    }, [alpacaClosingDate]);
    if (!alpacaClosingDate) {
        return null;
    }
    return (<AppView withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={paddingBottom} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <ScreenInfoHeader title="Here’s what to expect:" style={styles.screenInfoHeaderStyles}/>
          <Spacer h={16}/>
          <InfoCardWithIndex index="1" title="Exit your positions" subTitle={`You’ll need to sell your existing stocks before ${alpacaClosingDate} to continue investing with Emma.`}/>
          <InfoCardWithIndex index="2" title="No fees applied" subTitle="We won’t charge any FX fees on these sell orders during the transition."/>
          <InfoCardWithIndex index="3" title="Your Alpaca account will close" subTitle="After this date, any stocks still held in your Alpaca account will be sold as part of the transition, and the proceeds will be credited to your Emma wallet as cash."/>
        </Animated.ScrollView>
        <Button floating brand title="Continue" onPress={handleContinue}/>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default SecclMigrationExpectations;
const styles = StyleSheet.create({
    screenInfoHeaderStyles: {
        paddingBottom: rem(10),
    },
});
